import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";

import global from "../../config";
import Card from "../../UI/Card";

import Header from "../Header/Header";
import "./ManageAssets.css";
import ContextMenu from "./ContextMenu";
import Loader from "../../UI/Loader";
import ConfirmationDialog from "../../UI/ConfirmationDialog";

export default function Assets(props) {
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(true);
  const [listData, setListData] = useState({});
  const [searchText, showSearchText] = useState("");
  const [submitSearch, showSubmitSearch] = useState(false);
  const [addFormDialog, setAddFormDialog] = useState(false);

  const [records, setRecords] = useState("");
  const [totalRecord, setTotalRecord] = useState(0);
  const [totalAssets, setTotalAssets] = useState(0);
  const [totalFileSize, setTotalFileSize] = useState(0);
  const [totalDuration, setTotalDuration] = useState(0);
  const [percentagePackaged, setPercentagePackaged] = useState(0);
  const [percentageMetaData, setPercentageMetaData] = useState(0);
  const [showName, setShowName]=useState('');
  const [showCode, setShowCode]=useState('')

  const { type, showID } = useParams();
  const [typeTitle, setTypeTitle]=useState('')
  

  // [Start of Context Menu Option]
  const [actionID, setActionID] = useState("");
  const [toggleActionBlock, setToggleAction] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const toggleAction = () => {
    setToggleAction(!toggleActionBlock);
  };
  const editClickHandler = () => {
    toggleAction();
    editForm();
  };
  const deleteClickHandler = () => {
    setShowConfirm(true);
    toggleAction();
  };
  const clickHandler = (userID) => {
    toggleAction();
    setActionID(userID);
  };

  const onCancelClick = () => {
    setShowConfirm(false);
  };

  const onDeleteConfirmClick = async () => {
    const idToken = localStorage.getItem("idToken");
    const response = await axios.delete(global.apiURL + "/show/delete", {
      headers: { Authorization: "Bearer " + idToken },
    });
    if (response.status === 204) {
      console.log("Show Deleted");
    }
    setShowConfirm(false);
  };
  // [End of Context Menu Option]

  const editForm = (userID) => {
    setAddFormDialog(!addFormDialog);
  };

  const txtValue = (e) => {
    if (e.target.name === "txtSearch") {
      showSearchText(e.target.value);
    }
  };
  const clickSerach = () => {
    setShowLoader(true);
    showSubmitSearch(true);
  };
  const keyUpSearch = (e) => {
    if (e.target.value.length === 0 || e.key === "Enter") {
      clickSerach();
    }
  };


  const getData = async () => {
    const idToken = localStorage.getItem("idToken");
    let payLoad = { operation: "list" };

    if(type==='show' && showID){
      payLoad = { operation: "search", searchCriteria: { ShowId: showID }, };
    }
    else if(type==='in-complete'){
      setTypeTitle('Incomplete')
      payLoad = { operation: "search", searchCriteria: { status: 'INCOMPLETE' }, };
    }
    else if(type==='complete'){
      setTypeTitle('Complete')
      payLoad = { operation: "search", searchCriteria: { status: 'COMPLETE' }, };
    }

    if (idToken) {
      const response = await axios.post(global.apiURL + "/videos/", payLoad, {
        headers: { Authorization: "Bearer " + idToken },
      });
      if (response.data) {
        setListData(response.data.data);
        setRecords(response.data.data);
      } else {
        navigate("/");
      }
      
      if (showID) {
        const payLoadCreator = {
          operation: "search",
          searchCriteria: { _id: showID },
        };
        const respShow = await axios.post(
          global.apiURL + "/shows/",
          payLoadCreator,
          {
            headers: { Authorization: "Bearer " + idToken },
          }
        );
        if (respShow.data.data.length > 0) {
          setShowName(respShow.data.data[0].ShowName);
          setShowCode(respShow.data.data[0].ShowCode)
        }
      }

    }

    setShowLoader(false);
    showSubmitSearch(false);
  };

  const goToDetails = (assetID)=>{
    navigate(`/admin/assets/details/${assetID}`);
  }

  useEffect(() => {
    getData();
  }, [submitSearch, type]);

  useEffect(() => {
    let sumCount = 0;
    let sumAssets = 0;
    let sumFileSize = 0;
    let sumDuration = 0;
    let countPackaged = 0;
    let countMetaData = 0;
    if (records && records.length > 0) {
      records.forEach((record) => {
        sumCount = sumCount + 1;
        sumFileSize += parseFloat(record.fileSize) > 0 ? parseFloat(record.fileSize) : 0;
        sumDuration += parseFloat(record.duration) > 0 ? parseFloat(record.duration) : 0;
        if (record.video_filename && record.thumbnail_filename && record.transcript_filename) countPackaged++;
        if (record.metadata) countMetaData++;
      });
    }
    setTotalRecord(sumCount);
    setTotalAssets(sumAssets);
    setTotalFileSize(sumOfFileSizes([sumFileSize]));
    setTotalDuration(sumOfCreatorDuration([sumDuration]));
    setPercentagePackaged(((countPackaged / records.length) * 100).toFixed(2));
    setPercentageMetaData(((countMetaData / records.length) * 100).toFixed(2));
    console.log(countMetaData / records.length);
  }, [records]);

  const sumOfFileSizes = (fileSizes) => {
    if (!fileSizes || fileSizes.length === 0) {
      return 0;
    }
    const sumInBytes = fileSizes.reduce(
      (acc, size) => acc + parseInt(size, 10),
      0
    );
    const bytesPerGB = 1073741824;
    const sumInGB = sumInBytes / bytesPerGB;
    return Number(sumInGB.toFixed(2));
  };

  const sumOfCreatorDuration = (durations) => {
    // if (!durations || durations.length === 0) {
    //   return "0 mins";
    // }
    const sumInSeconds = durations;

    const hours = Math.floor(sumInSeconds / 3600);
    const minutes = Math.floor((sumInSeconds % 3600) / 60);

    if (hours === 0) {
      return `${minutes} mins`;
    } else {
      return `${hours} hrs ${minutes} mins`;
    }
  };

  const renderData = (data, serial) => {
    // List Template
    return (
      <Card>
        <div className="card-column">{serial}</div>
        <div className="card-column-large card-column-clickable" onClick={() => goToDetails(data._id)}>{data.video_title}</div>
        <div className="card-column">{sumOfCreatorDuration(data.duration)}</div>
        <div className="card-column">{data.season}</div>
        <div className="card-column">{data.episode}</div>
        <div className="card-column">
          {data.thumbnail_filename ? (
            <i className="learning-icon icon-yes">&#xe901;</i>
          ) : (
            <i className="learning-icon icon-no">&#xe900;</i>
          )}
        </div>
        <div className="card-column">
          {data.transcript_filename ? (
            <i className="learning-icon icon-yes">&#xe901;</i>
          ) : (
            <i className="learning-icon icon-no">&#xe900;</i>
          )}
        </div>
        <div className="card-column">
          {data.metadata ? (
            <i className="learning-icon icon-yes">&#xe901;</i>
          ) : (
            <i className="learning-icon icon-no">&#xe900;</i>
          )}
        </div>
        {/* <div>
          <button
            className="action-button"
            type="button"
            onClick={() => clickHandler(data._id)}
          >
            <i className="learning-icon icon-more">&#xe902;</i>
          </button>
        </div> */}
        {actionID === data._id && toggleActionBlock === true && (
          <ContextMenu
            id={data._id}
            onEditClick={editClickHandler}
            onDeleteClick={deleteClickHandler}
          />
        )}
      </Card>
    );
  };

  return (
    <>
      <div class="wrap-over-container">
        <Header />
        {showConfirm === true && (
          <ConfirmationDialog
            title="Delete Show"
            description="Are you sure you want to delete?"
            onCancelClick={onCancelClick}
            onSubmitClick={onDeleteConfirmClick}
            submitButtonText="Delete"
            cancelButtonText="Cancel"
          />
        )}
        <div className="admin-body">
          <div className="container">
            <div className="admin-panel">
              <div className="adheader">
                <h3>{type && type!=='show' ? `Assets ${typeTitle}` : `Shows > ${showName} (${showCode})`}</h3>
                <div className="admin-panel-header-right"></div>
              </div>
              <div className="adbody">
                {showLoader === true && (
                  <div style={{ height: "70vh", position: "relative" }}>
                    <Loader />
                  </div>
                )}
                {showLoader === false && (
                  <>
                    <Card type="header">
                      <div className="card-column-stats">
                        {totalRecord} <br /> ASSETS
                      </div>
                      <div className="card-column-stats">
                        {totalFileSize} GB <br /> FILESIZE
                      </div>
                      <div className="card-column-stats">
                        {totalDuration} <br /> DURATION
                      </div>
                      <div className="card-column-stats">
                        {percentageMetaData}% <br /> COMPLETE
                      </div>
                    </Card>
                    <Card type="header">
                      <div className="card-column">#</div>
                      <div className="card-column-large">ASSET NAME</div>
                      <div className="card-column">DURATION</div>
                      <div className="card-column">SEASON</div>
                      <div className="card-column">EPISODE</div>
                      <div className="card-column">THUMB</div>
                      <div className="card-column">CC</div>
                      <div className="card-column">METADATA</div>
                      {/* <div className="card-column-auto">Action</div> */}
                    </Card>
                    {listData.map((data, index) => (
                      <div key={data.ShowCode}>
                        {renderData(data, index + 1)}
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
